import classNames from 'classnames'
import React from 'react'

import { BaseAtom } from '../_BaseAtom'

export const FieldHint = BaseAtom<{ message: string }>(props => (
    <div className={classNames('text-xs', props.className)}>{props.message}</div>
))
